import React from 'react'
import styled from '@emotion/styled'
import { Checkbox } from 'antd'

const OrderTypeContainer = (props: {
  children: React.ReactNode
  enabled: boolean
  checked: boolean
  onChange?: () => void
  onCardClick?: () => void
  disabled?: boolean
}) => {
  const { enabled, onCardClick, onChange, checked, disabled = false } = props
  return (
    <OrderTypeWrapper>
      <Checkbox
        defaultChecked={enabled}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <div
        className={`card ${enabled ? '-active' : ''}`}
        onClick={disabled ? () => {} : onCardClick}
      >
        {props.children}
      </div>
    </OrderTypeWrapper>
  )
}

const OrderTypeWrapper = styled.div`
  align-items: center;
  margin-bottom: 8px;

  > .card {
    display: inline-flex;
    min-width: 350px;
    flex-direction: row;
    padding: 16px;
    border: 1px solid #dbd9df;
    border-radius: 4px;
    margin: 0 0 0 16px;
    cursor: pointer;

    &.-active {
      box-shadow: 0px 0px 0px 4px rgba(109, 118, 236, 0.2);
      border: 1px solid #4a4a68;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    > p {
      color: #4a4a68;
      text-transform: uppercase;
      font-weight: 500;
      margin: 0;
    }

    > span {
      color: #77778e;
      text-transform: none;
    }
  }

  .icon-container {
    display: flex;
    padding: 8px 0 0 0;
    flex-direction: column;
    align-items: center;
    margin-right: 16px;
    min-width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #4a4a68;

    svg {
      width: 24px;
      height: 24px;
      color: #fff;
    }

    &.selection {
      background: #d092dd;
    }
  }
`

export default OrderTypeContainer
